type Accompaniment = {
  person_id: number;
  first_name: string;
  last_name: string;
  nickname: string;
  unit_id: number;
  unit_display_name: string;
  date_of_birth: string;
};

export default function accompanimentList(node: HTMLElement): void {
  const accompanimentListContainer_ = node.querySelector<HTMLElement>(
    '[data-accompaniment-list]',
  );
  if (!accompanimentListContainer_) {
    console.error('Accompaniment list container not found');
    return;
  }
  const accompanimentListContainer = accompanimentListContainer_;

  const input_ = node.querySelector<HTMLInputElement>(
    '[data-accompaniment-input]',
  );
  if (!input_) {
    console.error('Accompaniment input not found');
    return;
  }
  const input = input_;

  // Find the dialog and its form
  const dialog = document.querySelector<HTMLDialogElement>(
    '#addAccompanimentDialog',
  );
  if (!dialog) {
    console.error('Add accompaniment dialog not found');
    return;
  }

  const dialogForm = dialog.querySelector<HTMLFormElement>(
    '[data-add-accompaniment-form]',
  );
  if (!dialogForm) {
    console.error('Add accompaniment form not found');
    return;
  }

  // Find the main form
  const mainForm = node.closest('form');
  if (!mainForm) {
    console.error('Main form not found');
    return;
  }

  // Copy form data from main form to dialog form before submission
  dialogForm.addEventListener('submit', (_e) => {
    // Copy all values from main form to dialog form's hidden fields
    const copyFields =
      dialogForm.querySelectorAll<HTMLInputElement>('[data-copy-field]');
    copyFields.forEach((field) => {
      const fieldName = field.getAttribute('data-copy-field');
      if (!fieldName) return;

      const mainFormField = mainForm.querySelector<HTMLInputElement>(
        `[name="${fieldName}"]`,
      );
      if (mainFormField) {
        field.value = mainFormField.value;
      }
    });
  });

  // Helper to update the JSON in the hidden input
  function updateAccompanimentJson(): void {
    const accompaniment: Accompaniment[] = [];
    accompanimentListContainer
      .querySelectorAll<HTMLElement>('.entityBox[data-person-id]')
      .forEach((accompanimentElement) => {
        const personIdStr = accompanimentElement.getAttribute('data-person-id');
        if (!personIdStr) return;

        const personId = parseInt(personIdStr, 10);

        // Find the accompaniment data in the current JSON to preserve all fields
        const currentAccompaniment: Accompaniment[] = JSON.parse(
          input.value || '[]',
        );
        const currentItem = currentAccompaniment.find(
          (a) => a.person_id === personId,
        );

        if (currentItem) {
          accompaniment.push(currentItem);
        }
      });

    const oldValue = input.value;
    const newValue = JSON.stringify(accompaniment);
    if (oldValue !== newValue) {
      input.value = newValue;

      // Dispatch change event to notify any listeners
      const event = new Event('change', { bubbles: true });
      input.dispatchEvent(event);
    }
  }

  // Add event listeners to all remove buttons
  accompanimentListContainer
    .querySelectorAll<HTMLButtonElement>('[data-remove-accompaniment]')
    .forEach((button) => {
      button.addEventListener('click', () => {
        const accompanimentElement = button.closest<HTMLElement>(
          '.entityBox[data-person-id]',
        );
        if (accompanimentElement) {
          accompanimentElement.remove();
          updateAccompanimentJson();
        }
      });
    });
}
